import '../styles/App.css';
import Header from './Header';
import '../styles/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import Toast from 'react-bootstrap/Toast'
import logo from '../assets/logo/logo.jpg'
import Postformulairepays from './Postformulairepays';
import Postformulaire from './Postformulaire';
import Loadfichier from './Loadfichier';
import Apprentissage from './Apprentissage';
import Adminpaysform from './Adminpaysform';
import PaysContext from "../contexts/payscontext";
import {useContext, useState} from 'react'
import Servicedata from './Servicedata';
import ServicemultiEtats from './ServicemultiEtats';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from './Footer';
import PutFormulairepays from './PutFormulairepays';
import PutFormulaire from './PutFormulaire';
import Toptitre from './Toptitre';
import Adminradioform from './Adminradioform';



function App() {
  //const valeurcontext = useContext(PaysContext)
  let payscourant =""
  const adminpaysdroit = false

  const [userRadio, SetUserRadio] = useState(false) 


  function deconnecter(){
    window.location.reload();
  }

  /*if (adminpaysdroit === true) {
    return <Servicedata/> 
  } else{
    
    return (
      <div>
      <ServicemultiEtats/>
      <Postformulaire adminExiste={true}/>
    </div>
     )
  }   */   
  


  return (
    

    <div className='container-fluid'>

         <div className='row '>
            <div className='container-fluid topbg'>
              <Toptitre/>
              <ServicemultiEtats/>
            </div>
          </div>
          <div className='row '>
            < div className='container'>    
                <button className='btn ' onClick={() => {SetUserRadio(false)}}><i className="bi bi-cloud-lightning-rain"></i> SHMN </button>
                <button className='btn ' onClick={() => {SetUserRadio(true)}}><i className="bi bi-volume-up"></i> Radio </button>                     
                {userRadio && <Adminradioform/>}
                {!userRadio && <Adminpaysform/>}     
                          
            </div>
          </div>
          <div className='row'>
            < div className='jumbotron-fluid'>       
                <Footer/> 
            </div>
          </div>


          

        


    </div>

 
    
  );
}

export default App;
